/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function SlidersIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M9 25c-1.125 0-2 .938-2 2 0 1.125.875 2 2 2 1.063 0 2-.875 2-2 0-1.062-.937-2-2-2m4.75.5H34.5c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5H13.75C13.125 30.563 11.188 32 9 32c-2.812 0-5-2.187-5-5 0-2.75 2.188-5 5-5 2.188 0 4.125 1.5 4.75 3.5M29 13c0 1.125.875 2 2 2 1.063 0 2-.875 2-2 0-1.062-.937-2-2-2-1.125 0-2 .938-2 2m-2.812-1.5C26.813 9.5 28.75 8 31 8c2.75 0 5 2.25 5 5 0 2.813-2.25 5-5 5-2.25 0-4.187-1.437-4.812-3.5H5.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5z"/>}
        </IconWrapper>);
}
